import { createLeadClient } from './client';
import { LeadIdempotency } from './idempotency';

function fallbackUuid(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/gu, (char) => {
    const random = (Math.random() * 16) | 0;
    const value = char === 'x' ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}

export function createBrowserLeadClient(endpoint: string) {
  const client = createLeadClient({ endpoint });
  const idempotency = new LeadIdempotency(
    {
      get: (key) => {
        try {
          return sessionStorage.getItem(key);
        } catch {
          return null;
        }
      },
      set: (key, value) => {
        try {
          sessionStorage.setItem(key, value);
        } catch {
          // The key still protects the current request in memory through the caller.
        }
      },
    },
    {
      uuid: () =>
        typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : fallbackUuid(),
    },
  );
  return { client, idempotency };
}

export { LeadSubmissionError } from './client';
